import React, { useLayoutEffect, useRef } from 'react';
import useSiteStatus from '../hooks/useSiteStatus';
import { formatBackDate } from '../services/siteStatusService';
import './ClosureBanner.css';

// Shown while the bakery is away. Controlled from the /admin page.
const ClosureBanner = () => {
  const { away, backOn, message } = useSiteStatus();
  const bannerRef = useRef(null);

  // Publish the banner's height so the header and page content sit below it
  useLayoutEffect(() => {
    const root = document.documentElement;
    const el = bannerRef.current;
    if (!away || !el) {
      root.style.removeProperty('--banner-height');
      return undefined;
    }
    const update = () => root.style.setProperty('--banner-height', `${el.offsetHeight}px`);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => {
      observer.disconnect();
      root.style.removeProperty('--banner-height');
    };
  }, [away, backOn, message]);

  if (!away) return null;

  const backDate = formatBackDate(backOn);

  return (
    <div className="closure-banner" ref={bannerRef}>
      <p className="closure-message">
        {message ? (
          message
        ) : (
          <>
            We are not accepting new orders
            {backDate ? <> until <strong>{backDate}</strong></> : ' right now'}. We look forward to baking for you soon!
          </>
        )}
      </p>
    </div>
  );
};

export default ClosureBanner;
